import { Input, Component, OnInit, OnDestroy, Inject, ChangeDetectionStrategy, AfterViewInit,ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import {FormBuilder, FormGroup,FormArray, Validators} from "@angular/forms";
import {Router, ActivatedRoute} from "@angular/router";
import { MatDialog ,MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../../../../environments/environment';
import { CommonService } from '../../../../../Service/common/common-service.service';
import{FileAttachmentClass}from '../../../../../Class/common/file-attachment/file-attachment-class';
import{Da9000Class}from '../../../../../Class/da9000/da9000-class';

import { HttpClient, HttpEventType } from '@angular/common/http';
import { from } from 'rxjs';
import {DatePipe} from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import{Da5610Service}from '../../../../../Service/da5610/da5610-service.service'
import { DomSanitizer, SafeResourceUrl, SafeHtml, SafeUrl } from '@angular/platform-browser';
import * as mammoth from 'mammoth';
import * as XLSX from 'xlsx-js-style';
@Component({
  selector: 'kt-file-attachment',
  templateUrl: './file-attachment.component.html',
  styleUrls: ['./file-attachment.component.scss']
})

export class FileAttachmentComponent implements OnInit, OnDestroy {

  currentUrl:string;

  // Slide-panel-from-right presentation: the host is reparented to be
  // a direct child of <body> so position:fixed is immune to the
  // MatDialog/CDK overlay's own transform/overflow ancestors (same
  // fix already used for the New-screen slide panels this dialog is
  // usually opened from) - restored to its original position in
  // ngOnDestroy before Angular's own view-destroy cleanup runs.
  private originalParentNode: Node = null;
  private originalNextSibling: Node = null;
  isDragOver = false;

  icoDoc: string;
  icoImg: string;
  icoPdf: string;
  icoPpt: string;
  icoTxt: string;
  icoUnknown: string;
  icoXls: string;
  icoZip: string;
  objDa9000Class:Da9000Class;
   lblPageTitle: string = "";
  lblBack: string;
  lblClear: string;
  lblDelete: string;
  lblSave: string;
  lblSave_Exit: string;
  lblSave_Duplicate: string;
  lblSave_Continue: string;
  lblBack_to_Fin_Tool: string;
  lblClear_Changes_Tool: string;
  lblDelete_Selected_Entry_Tool: string;
  lblSave_Exit_Tool: string;
  lblDelMaster_Heading: string;
  lblDelMaster_Message: string;
  lblDelMaster_Progress_Message: string;
  lblDelMaster_Confirmation: string;
  lblDelMaster_Cancel: string;
  lblDelMasterDelete: string;
  lblSelect: string;
  lblDuplication: string;
  lblMandatory: string;
  lblSystemError: string;
  lblFileAttach:string;
  lblSelectFile:string;
  lblDownload:string;
  // Form:FormGroup;
  private fileList: Array<any> = [];
  VarCompid: string;

  // In-panel preview for an already-attached file (PDF/image/HTML/text/SQL/Word/Excel rendered
  // inline; ZIP/RAR and anything else stays Download-only) - a slide panel nested on top of
  // this dialog's own panel, opened from the file list's icon/name.
  showFilePreview: boolean = false;
  previewField: any = null;
  previewFileName: string = '';
  previewKind: 'image' | 'pdf' | 'html' | 'text' | 'word' | 'excel' | 'unsupported' = 'unsupported';
  previewLoading: boolean = false;
  previewErrorMessage: string = '';
  previewImageSafeUrl: SafeUrl = null;
  previewSafeResourceUrl: SafeResourceUrl = null;
  previewHtmlSafeResourceUrl: SafeResourceUrl = null;
  previewSafeHtml: SafeHtml = null;
  previewTextContent: string = '';
  previewExcelSheetNames: string[] = [];
  previewExcelActiveSheet: string = '';
  private previewExcelWorkbook: XLSX.WorkBook = null;
  private previewObjectUrl: string = null;

  constructor(   private sundryservice:Da5610Service,private formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute,
    private objCommonService:CommonService,public dialog: MatDialog,private layoutUtilsService: LayoutUtilsService,private modalService: NgbModal, public dialogRef: MatDialogRef<FileAttachmentComponent>,
    @Inject(MAT_DIALOG_DATA) public ParamData: any, private changeDetectorRef: ChangeDetectorRef, private hostElRef: ElementRef, private http: HttpClient, private sanitizer: DomSanitizer ) {
   }


  ngOnInit() {
    const hostEl = this.hostElRef.nativeElement;
    this.originalParentNode = hostEl.parentNode;
    this.originalNextSibling = hostEl.nextSibling;

    // The MatDialog container this content is being moved out of still
    // sits in its original centered position with its own background/
    // padding/box-shadow/fixed size from the dialog theme - once the
    // content is gone that leaves a plain white box behind. Neutralise
    // that one DOM node directly (not a shared CSS class) so it has no
    // visible footprint, without touching any other dialog on the page.
    const dialogContainerEl = this.originalParentNode as HTMLElement;
    if (dialogContainerEl && dialogContainerEl.style) {
      dialogContainerEl.style.background = 'transparent';
      dialogContainerEl.style.boxShadow = 'none';
      dialogContainerEl.style.padding = '0';
      dialogContainerEl.style.width = '0';
      dialogContainerEl.style.height = '0';
      dialogContainerEl.style.minWidth = '0';
      dialogContainerEl.style.minHeight = '0';
      dialogContainerEl.style.overflow = 'visible';
    }

    document.body.appendChild(hostEl);

    this.currentUrl = environment.baseUrl.replace("api/", "");
    this.icoDoc = "UploadFiles/DocManager/Default/doc.png";
    this.icoImg = "UploadFiles/DocManager/Default/img.png";
    this.icoPdf = "UploadFiles/DocManager/Default/pdf.png";
    this.icoPpt = "UploadFiles/DocManager/Default/ppt.png";
    this.icoTxt = "UploadFiles/DocManager/Default/txt.png";
    this.icoUnknown = "UploadFiles/DocManager/Default/unknown.png";
    this.icoXls = "UploadFiles/DocManager/Default/xls.png";
    this.icoZip = "UploadFiles/DocManager/Default/zip.png";
    
    this.onGetCommonControlNames();
  }
    onGetCommonControlNames()
  {
    this.sundryservice.GetCommonControlNames(47).subscribe(CommonControlNamesList=>{
      
      CommonControlNamesList.forEach(data => {
   
        if(data.GeneralMsgId == 0)
        {
          this.lblPageTitle = data.Message;
        }
        else if(data.GeneralMsgId == 7)
        {
          this.lblBack = data.Message;
        }
        else if(data.GeneralMsgId == 8)
        {
          this.lblClear = data.Message;
          
        }
        else if(data.GeneralMsgId == 9)
        {
          this.lblDelete = data.Message;
          
        }
        else if(data.GeneralMsgId == 10)
        {
          this.lblSave = data.Message;

        }
        else if(data.GeneralMsgId == 11)
        {
          this.lblSave_Exit = data.Message;
        }
        else if(data.GeneralMsgId == 12)
        {
          this.lblSave_Duplicate = data.Message;
        }
        else if(data.GeneralMsgId == 13)
        {
          this.lblSave_Continue = data.Message;
        }
        else if(data.GeneralMsgId == 14)
        {
          this.lblBack_to_Fin_Tool = data.Message;
        }
        else if(data.GeneralMsgId == 15)
        {
          this.lblClear_Changes_Tool = data.Message;
        }
        else if(data.GeneralMsgId == 16)
        {
          this.lblDelete_Selected_Entry_Tool = data.Message;
        }
        else if(data.GeneralMsgId == 17)
        {
          this.lblSave_Exit_Tool = data.Message;
        }
        else if(data.GeneralMsgId == 18)
        {
          this.lblDelMaster_Heading = data.Message;
        }
        else if(data.GeneralMsgId == 19)
        {
          this.lblDelMaster_Message = data.Message;
        }
        else if(data.GeneralMsgId == 20)
        {
          this.lblDelMaster_Progress_Message = data.Message;
        }
        else if(data.GeneralMsgId == 21)
        {
          this.lblDelMaster_Confirmation = data.Message;
        }
        else if(data.GeneralMsgId == 22)
        {
          this.lblDelMaster_Cancel = data.Message;
        }
        else if(data.GeneralMsgId == 23)
        {
          this.lblDelMasterDelete = data.Message;
        }
        else if(data.GeneralMsgId == 24)
        {
          this.lblSelect = data.Message;
        } 
        else if(data.GeneralMsgId == 27)
        {
          this.lblDuplication = data.Message;
        }
        else if(data.GeneralMsgId == 28)
        {
          this.lblMandatory = data.Message;
        }
        else if(data.GeneralMsgId == 29)
        {
          this.lblSystemError = data.Message;
        } 
        else if(data.GeneralMsgId == 52)
        {
          this.lblFileAttach = data.Message;
        }  
         else if(data.GeneralMsgId == 53)
        {
          this.lblSelectFile = data.Message;
        } 
         else if(data.GeneralMsgId == 44)
        {
          this.lblDownload = data.Message;
        } 
       
      });

      this.changeDetectorRef.detectChanges();
    })
  }
  ngOnDestroy(): void {
    // Restore the host to where Angular originally rendered it before
    // the view is torn down, otherwise Angular's own cleanup can throw
    // trying to remove a node that's no longer where it expects.
    const hostEl = this.hostElRef.nativeElement;
    if (this.originalParentNode) {
      if (this.originalNextSibling && this.originalNextSibling.parentNode === this.originalParentNode) {
        this.originalParentNode.insertBefore(hostEl, this.originalNextSibling);
      } else {
        this.originalParentNode.appendChild(hostEl);
      }
    }
    this.revokePreviewObjectUrl();
  }

  // Opens the nested preview slide panel for an already-listed file (existing attachment or one
  // just picked in this session - both share the same fileList item shape). ZIP/RAR can't be
  // rendered by any of the paths below, so it's Download-only: no panel, just a toast.
  openFilePreview(field: any): void {
    const name: string = field.FileNameSelected || field.FileNameServer || '';
    const ext = (name.split('.').pop() || '').toLowerCase();

    if (ext === 'zip' || ext === 'rar') {
      this.layoutUtilsService.showActionNotification('Preview is not available for ZIP/RAR files. Please use Download.', MessageType.Read, 4000, true, false, 4000, "bottom");
      return;
    }

    this.previewField = field;
    this.previewFileName = field.FileNameSelected;
    this.previewErrorMessage = '';
    this.previewTextContent = '';
    this.previewSafeHtml = null;
    this.previewImageSafeUrl = null;
    this.previewSafeResourceUrl = null;
    this.previewHtmlSafeResourceUrl = null;
    this.previewExcelSheetNames = [];
    this.previewExcelActiveSheet = '';
    this.previewExcelWorkbook = null;
    this.previewLoading = true;
    this.showFilePreview = true;

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].indexOf(ext) !== -1) {
      this.previewKind = 'image';
    } else if (ext === 'pdf') {
      this.previewKind = 'pdf';
    } else if (ext === 'html' || ext === 'htm') {
      this.previewKind = 'html';
    } else if (['txt', 'csv', 'log', 'sql'].indexOf(ext) !== -1) {
      this.previewKind = 'text';
    } else if (ext === 'doc' || ext === 'docx') {
      this.previewKind = 'word';
    } else if (ext === 'xls' || ext === 'xlsx') {
      this.previewKind = 'excel';
    } else {
      this.previewKind = 'unsupported';
    }

    if (this.previewKind === 'unsupported') {
      this.previewLoading = false;
      this.previewErrorMessage = 'Preview is not available for this file type. Please use Download.';
      this.changeDetectorRef.detectChanges();
      return;
    }

    const fileUrl = this.currentUrl + field.Folder + field.FileNameServer;
    this.http.get(fileUrl, { responseType: 'blob' }).subscribe(
      blob => this.renderFilePreview(blob, ext),
      error => {
        console.error('Preview failed for', fileUrl, error);
        this.previewLoading = false;
        this.previewErrorMessage = 'This file could not be loaded for preview. Please use Download.';
        this.changeDetectorRef.detectChanges();
      }
    );
  }

  private renderFilePreview(blob: Blob, ext: string): void {
    if (this.previewKind === 'image') {
      this.revokePreviewObjectUrl();
      this.previewObjectUrl = URL.createObjectURL(blob);
      // Angular's default URL sanitizer doesn't recognise the blob: scheme as safe (its
      // allow-list is http(s)/ftp/mailto/tel/file/sms plus scheme-less relative URLs), so a
      // raw blob: URL bound to [src] gets silently rewritten to "unsafe:..." and never loads
      // - it has to be explicitly marked trusted here.
      this.previewImageSafeUrl = this.sanitizer.bypassSecurityTrustUrl(this.previewObjectUrl);
      this.previewLoading = false;
      this.changeDetectorRef.detectChanges();
      return;
    }

    if (this.previewKind === 'pdf') {
      this.revokePreviewObjectUrl();
      // The static file URL's response doesn't always carry an application/pdf Content-Type,
      // which some browsers need to render (rather than download) the iframe's blob: URL.
      const pdfBlob = blob.type === 'application/pdf' ? blob : new Blob([blob], { type: 'application/pdf' });
      this.previewObjectUrl = URL.createObjectURL(pdfBlob);
      this.previewSafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewObjectUrl);
      this.previewLoading = false;
      this.changeDetectorRef.detectChanges();
      return;
    }

    if (this.previewKind === 'html') {
      this.revokePreviewObjectUrl();
      // Rendered as an actual page (not escaped source) - it's the only one of these types a
      // browser can display natively/faithfully. It's still an uploaded file from any user,
      // so the iframe is sandboxed with every privilege withheld (no "allow-scripts" etc.),
      // otherwise an attachment containing <script> would run as a stored-XSS payload against
      // whoever previews it.
      const htmlBlob = blob.type === 'text/html' ? blob : new Blob([blob], { type: 'text/html' });
      this.previewObjectUrl = URL.createObjectURL(htmlBlob);
      this.previewHtmlSafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewObjectUrl);
      this.previewLoading = false;
      this.changeDetectorRef.detectChanges();
      return;
    }

    if (this.previewKind === 'text') {
      const reader = new FileReader();
      reader.onload = () => {
        this.previewTextContent = String(reader.result || '');
        this.previewLoading = false;
        this.changeDetectorRef.detectChanges();
      };
      reader.onerror = () => this.failPreview();
      reader.readAsText(blob);
      return;
    }

    if (this.previewKind === 'word') {
      // mammoth only understands the modern .docx (OOXML) format - the legacy binary .doc
      // format has no practical pure-JS renderer, so it stays Download-only with a note.
      if (ext === 'doc') {
        this.previewLoading = false;
        this.previewErrorMessage = 'Preview is not supported for the older .doc format. Please use Download.';
        this.changeDetectorRef.detectChanges();
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        mammoth.convertToHtml({ arrayBuffer: reader.result as ArrayBuffer })
          .then(result => {
            this.previewSafeHtml = this.sanitizer.bypassSecurityTrustHtml(result.value);
            this.previewLoading = false;
            this.changeDetectorRef.detectChanges();
          })
          .catch(() => this.failPreview());
      };
      reader.onerror = () => this.failPreview();
      reader.readAsArrayBuffer(blob);
      return;
    }

    if (this.previewKind === 'excel') {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const data = new Uint8Array(reader.result as ArrayBuffer);
          this.previewExcelWorkbook = XLSX.read(data, { type: 'array' });
          this.previewExcelSheetNames = this.previewExcelWorkbook.SheetNames;
          this.renderExcelSheet(this.previewExcelSheetNames[0]);
          this.previewLoading = false;
          this.changeDetectorRef.detectChanges();
        } catch (e) {
          this.failPreview();
        }
      };
      reader.onerror = () => this.failPreview();
      reader.readAsArrayBuffer(blob);
    }
  }

  // Every sheet in the workbook is kept in memory once read, so switching the active tab is
  // instant and doesn't need to re-fetch or re-parse the file.
  selectExcelSheet(sheetName: string): void {
    if (!this.previewExcelWorkbook || sheetName === this.previewExcelActiveSheet) {
      return;
    }
    this.renderExcelSheet(sheetName);
  }

  private renderExcelSheet(sheetName: string): void {
    const html = XLSX.utils.sheet_to_html(this.previewExcelWorkbook.Sheets[sheetName]);
    this.previewExcelActiveSheet = sheetName;
    this.previewSafeHtml = this.sanitizer.bypassSecurityTrustHtml(html);
    this.changeDetectorRef.detectChanges();
  }

  private failPreview(): void {
    this.previewLoading = false;
    this.previewErrorMessage = 'This file could not be loaded for preview. Please use Download.';
    this.changeDetectorRef.detectChanges();
  }

  private revokePreviewObjectUrl(): void {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
      this.previewObjectUrl = null;
    }
  }

  closeFilePreview(): void {
    this.revokePreviewObjectUrl();
    this.showFilePreview = false;
    this.previewField = null;
    this.previewSafeResourceUrl = null;
    this.previewHtmlSafeResourceUrl = null;
    this.previewSafeHtml = null;
    this.previewImageSafeUrl = null;
    this.previewTextContent = '';
    this.previewErrorMessage = '';
    this.previewExcelSheetNames = [];
    this.previewExcelActiveSheet = '';
    this.previewExcelWorkbook = null;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length) {
      this.uploadFile(event.dataTransfer.files, 1);
    }
  }

  formatSize(bytes: number): string {
    if (bytes == null) return '';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  ngAfterViewInit(): void {
    if(this.ParamData.AutoId > 0)
    {
    var objDa9000Class = new Da9000Class();
    objDa9000Class.TableName=this.ParamData.TableName;
    objDa9000Class.AutoId = this.ParamData.AutoId;
    this.objCommonService.SelectAttachments(objDa9000Class).subscribe(data=>{
          this.fileList = data;
          this.changeDetectorRef.detectChanges();
       })
     }
  };

  // Handles the whole FileList from either the file input (multiple)
  // or a drag-and-drop, uploading each selected file independently -
  // same per-file upload logic as before, just looped instead of only
  // ever reading files[0].
  public uploadFile = (files, index: number) => {
    if (!files || files.length === 0) {
      return;
    }
    Array.from(files as FileList).forEach((fileToUpload: File) => {
      this.uploadSingleFile(fileToUpload);
    });
  }

  private uploadSingleFile(fileToUpload: File) {
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.objCommonService.TempFileCreate(formData).subscribe(event=>
      {
        if (event.type === HttpEventType.UploadProgress)
          var progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          var message = 'Upload success.';
          var savedfilename=event.body.dbPath;
          var geturl='UploadFiles/DocManager/temp/'+savedfilename;
          // this.imageURL = environment.baseUrl.replace("api/", "") + 'UploadFiles/DocManager/temp/'+savedfilename;

          // var fileName =(<HTMLFormElement>document.getElementById("fileName")) ;
          // fileName.value = fileToUpload.name;

          const newAttribute: any = {};
          newAttribute.FileId = 0;
          newAttribute.FileNameSelected = fileToUpload.name;
          newAttribute.FileNameServer = savedfilename;
          newAttribute.Folder = 'UploadFiles/DocManager/temp/';
          newAttribute.FileSize = fileToUpload.size;
          // Needed so Download works on a just-attached (not yet
          // Saved) file too - without this, PageName was undefined
          // for freshly uploaded files and only ever got set for
          // attachments already persisted via onSave().
          newAttribute.PageName = this.ParamData.PageName;

          if(savedfilename.endsWith("doc") == true || savedfilename.endsWith("docx") == true)
          {
            newAttribute.FileIcon = this.icoDoc;
          }
          else if(savedfilename.endsWith("xls") == true || savedfilename.endsWith("xlsx") == true)
          {
            newAttribute.FileIcon = this.icoXls;
          }
          else if(savedfilename.endsWith("txt") == true || savedfilename.endsWith("csv") == true)
          {
            newAttribute.FileIcon = this.icoTxt;
          }
          else if(savedfilename.endsWith("pdf") == true)
          {
            newAttribute.FileIcon = this.icoPdf;
          }
          else if(savedfilename.endsWith("ppt") == true || savedfilename.endsWith("pptx") == true)
          {
            newAttribute.FileIcon = this.icoPpt;
          }
          else if(savedfilename.endsWith("zip") == true || savedfilename.endsWith("rar") == true)
          {
            newAttribute.FileIcon = this.icoZip;
          }
          else if(savedfilename.endsWith("jpg") == true || savedfilename.endsWith("jpeg") == true|| savedfilename.endsWith("png") == true|| savedfilename.endsWith("gif") == true|| savedfilename.endsWith("tif") == true)
          {
            newAttribute.FileIcon = this.icoImg;
          }
          else
          {
            newAttribute.FileIcon = this.icoUnknown;
          }

          this.fileList.push(newAttribute);

          this.changeDetectorRef.detectChanges();
        }
      }

    )
  }

  OpenFile(file)
  {
    window.open(file);
  }

  removeAttachment(index)
  {
    this.fileList.splice(index, 1);
    // this.objDa9000Class.AttachmentList.splice(index, 1);
  }

  onClear()
  {
    document.getElementById('btnSave').style.display = 'block';   
    document.getElementById('btnSaveMenu').style.display = 'block';
    this.fileList.splice(0);
  }

  onSave()
  {
    var objDa9000Class = new Da9000Class();
    objDa9000Class.TableName=this.ParamData.TableName;
    objDa9000Class.AutoId = this.ParamData.AutoId;
  
    var objDa9000Class = new Da9000Class();
    var objFileAttachmentClass = new FileAttachmentClass();
    objDa9000Class.AttachmentList = [];
    var strTempUrl = environment.baseUrl.replace("api/", "");
    if(this.fileList.length==0)
    {
      objFileAttachmentClass = new FileAttachmentClass();
     
      objFileAttachmentClass.TableName = this.ParamData.TableName;
      objFileAttachmentClass.AutoId = this.ParamData.AutoId;
      objDa9000Class.AttachmentList.push(objFileAttachmentClass);

    }
    for (var i = 0; i <= this.fileList.length - 1; i++)
    {
      objFileAttachmentClass = new FileAttachmentClass();
      objFileAttachmentClass.FileId = this.fileList[i].FileId;
      objFileAttachmentClass.FileNameSelected = this.fileList[i].FileNameSelected;
      objFileAttachmentClass.FileNameServer = this.fileList[i].FileNameServer;
      objFileAttachmentClass.Folder = this.fileList[i].Folder.replace(strTempUrl, "");
      objFileAttachmentClass.FkPageId = this.ParamData.FkPageId;
      objFileAttachmentClass.PageName = this.ParamData.PageName;
      objFileAttachmentClass.TableName = this.ParamData.TableName;
      objFileAttachmentClass.AutoId = this.ParamData.AutoId;

      objDa9000Class.AttachmentList.push(objFileAttachmentClass);
    }

    this.objCommonService.Save(objDa9000Class).subscribe(data=>{
      if(data.IsSuccess)
      {
        this.Close();
      }
      else if(data.ErrorCodes="Empty Page"){
        this.Close();
      }
      else{
        this.layoutUtilsService.showActionNotification(data.ErrorCodes, MessageType.Read, 5000, true, false, 5000, "bottom");
      }
    })
  }

  Close()
  {
    this.dialogRef.close(`${""}`);
  }
  // Downloads directly from the file's own URL (same URL OpenFile used
  // to open it) rather than the DownloadAttachment API, which looks
  // the file up by its saved database record - a just-attached file
  // (before Save) only exists as a temp file on disk with no DB
  // record yet, so that API can never find it. Fetching the direct
  // URL works uniformly for both a brand new attachment and an
  // already-saved one.
  downloadFile(fileUrl: string, originalName: string) {
    this.http.get(fileUrl, { responseType: 'blob' })
    .subscribe(
      blob => {

      if (!blob || blob.size === 0) {
        console.error('Download failed: empty response body for', fileUrl);
        this.layoutUtilsService.showActionNotification('File could not be downloaded (empty response).', MessageType.Read, 5000, true, false, 5000, "bottom");
        return;
      }

      const objectUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = objectUrl;

      a.download = originalName;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(objectUrl);

    },
    error => {
      console.error('Download failed for', fileUrl, error);
      this.layoutUtilsService.showActionNotification('File could not be downloaded. Please try again.', MessageType.Read, 5000, true, false, 5000, "bottom");
    });
}
}


